<template>
  <m-card
    no-padding
    class="move-space-card"
  >
    <m-content
      padding-xs
    >
      <space-selector
        :value="parents"
        :placeholder="$t('moveSpaceCard.placeholder')"
        :restricted-spaces="items"
        :property-label="property.label"
        full-width
        close-on-select
        auto-focus
        @input="changeParent"
      />
      <m-divider
        no-border
        xxs
      />
      <div
        class="_actions"
      >
        <m-btn
          block
          color="primary"
          :loading="loading"
          @click="submit"
        >
          {{ $t('moveSpaceCard.move') }}
        </m-btn>
      </div>
    </m-content>
  </m-card>
</template>

<script>
import SpaceSelector from '@/components/filter/SpaceSelector.vue';
import useSpaces from '@/composables/space/spaces';
import { logCatch } from '@/lib/logger/logger';

export default {
  name: 'MoveSpaceCard',
  props: {
    entity: {
      type: Object,
      required: true,
    },
    property: {
      type: Object,
      required: true,
    },
  },
  setup() {
    const spacesSvc = useSpaces();

    return { spacesSvc };
  },
  emits: ['close', 'updated'],
  components: { SpaceSelector },
  data() {
    return {
      parents: [],
      loading: false,
    };
  },
  computed: {
    items() {
      const excludedIds = this.calculateExcludedItems().map((i) => i.uid);
      return this.spacesSvc.spaces.value.filter((o) => !excludedIds.includes(o.uid));
    },
  },
  methods: {
    changeParent(value) {
      this.parents = value;
    },
    submit() {
      this.update();
    },
    maybeSubmit(event) {
      if (event.key === 'Enter') {
        this.submit();
      }
    },
    calculateExcludedItems() {
      const getChildren = (option, level, acc) => {
        if (level >= 10 || option.children.length === 0) {
          return [...acc, option];
        }

        const children = option.children.reduce((res, child) => [...res, ...getChildren(child, level + 1, [])], []);

        return [...acc, ...children, option];
      };

      return getChildren(this.entity, 1, []);
    },
    update() {
      this.loading = true;
      this.spacesSvc.updateSpace(
        {
          uid: this.entity.uid,
          parents: this.parents,
        },
      )
        .then(() => {
          this.$emit('close');
          this.$emit('updated');
        })
        .catch(logCatch(() => {
          this.$showSnackbar({ color: 'error', message: this.$t('error.default') });
        }));
    },
  },
  created() {
    window.addEventListener('keydown', this.maybeSubmit);
    this.parent = this.entity.parents;
  },
  beforeUnmount() {
    window.removeEventListener('keydown', this.maybeSubmit);
  },
};
</script>

<style scoped lang="scss" type="text/scss">
  .move-space-card {
    min-width: 25rem;
  }

</style>
